// #REF: https://github.com/simmatrix/vue-google-auth/blob/master/index.js

export default {
  load (config) {
    return new Promise((resolve, reject) => {
      initClient(config).then(() => {
        resolve()
      })
    })
  },
  signIn () {
    return window.gapi.auth2.getAuthInstance().signIn()
  },
  signOut () {
    return window.gapi.auth2.getAuthInstance().signOut()
  }
}

function initClient (config) {
  return new Promise(function (resolve, reject) {
    window.gapi.load('auth2', function () {
      window.gapi.auth2.init(config)
      resolve()
    })
  })
}
